import {ActionList, CounterLabel} from '@primer/react'
import type {Icon} from '@primer/octicons-react'
import type {TimelineActivityGroupKey} from '../../../../contexts/DockedPanelContext'
import {useSidebarActivityOpenTimeline} from './use-sidebar-activity-open-timeline'
import {useEffectiveSelection} from '../../data/use-effective-selection'
import styles from '../ActivityRows.module.css'

interface SidebarActivityRowProps {
  icon: Icon
  categoryLabel: string
  /** Summary forwarded as the Timeline panel heading. */
  label: string
  /** The activity group key forwarded to the Timeline panel on click. */
  group: TimelineActivityGroupKey
  /** How many items the group should contain (from summary count). */
  expectedCount: number
}

export function SidebarActivityRow({icon: Icon, categoryLabel, label, group, expectedCount}: SidebarActivityRowProps) {
  const openTimeline = useSidebarActivityOpenTimeline()
  const {effectiveSelection} = useEffectiveSelection()
  const since = effectiveSelection?.timestamp

  return (
    <ActionList.Item
      className={styles.labelRow}
      onSelect={event => openTimeline(event.currentTarget, {label, group, since, expectedCount})}
    >
      <ActionList.LeadingVisual>
        <Icon />
      </ActionList.LeadingVisual>
      {categoryLabel}
      <ActionList.TrailingVisual className={styles.count}>
        <CounterLabel>{expectedCount}</CounterLabel>
      </ActionList.TrailingVisual>
    </ActionList.Item>
  )
}
